import {
  GET_APP_SWITCHER_URL,
  GET_APP_SWITCHER_URL_SUCCESS,
  GET_APP_SWITCHER_URL_ERROR,
  RESET_APP_SWITCHER_DATA
} from "./constants";
import ApiService from "../utils/ApiService";

export const handleAppSwitch = async (dispatch, appId) => {
  dispatch({ type: GET_APP_SWITCHER_URL, payload: appId });
  try {
    const payload = await ApiService.getAppSwitcherUrl(appId);
    if (payload.route) {
      dispatch({ type: GET_APP_SWITCHER_URL_SUCCESS, payload });
    } else {
      dispatch({
        type: GET_APP_SWITCHER_URL_ERROR
      });
    }
  } catch (error) {
    dispatch({
      type: GET_APP_SWITCHER_URL_ERROR
    });
  }
};

export const resetAppSwitcherData = (dispatch) => {
  dispatch({ type: RESET_APP_SWITCHER_DATA });
};
